import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { TIMETABLE_SERVICES_DISRUPTIONS } from 'store/queries';
import { isDisruptedTrainsInSearchResultsEnabled } from 'utils/featureFlags';
import { shouldQueryDisruptions, toTravelDate } from 'utils/trainDisruptions';

const useDirection = ({ enabled, date, originUic, destinationUic }) => {
  const { data } = useQuery(TIMETABLE_SERVICES_DISRUPTIONS, {
    variables: { date, originUic, destinationUic },
    skip: !enabled || !shouldQueryDisruptions({ date, originUic, destinationUic }),
    fetchPolicy: 'no-cache'
  });

  return useMemo(() => data?.timetableServices ?? [], [data?.timetableServices]);
};

const useTrainDisruptionsQuery = ({ outboundDate, inboundDate, outboundInfo, inboundInfo }) => {
  const enabled = isDisruptedTrainsInSearchResultsEnabled();

  const outbound = useDirection({
    enabled,
    date: toTravelDate(outboundDate),
    originUic: outboundInfo?.originUIC,
    destinationUic: outboundInfo?.destinationUIC
  });

  const inbound = useDirection({
    enabled,
    date: toTravelDate(inboundDate),
    originUic: inboundInfo?.originUIC,
    destinationUic: inboundInfo?.destinationUIC
  });

  return { outbound, inbound };
};

export default useTrainDisruptionsQuery;
